import { AcUnit } from '@mui/icons-material'
import { ApplianceConfigAirAirHeatPump } from './Appliance'
import { StrategySliders } from '../../components/StrategySliders'
import { TemperatureRelayAppliance } from './TemperatureRelayAppliance'

export class AirAirHeatPumpAppliance extends TemperatureRelayAppliance<ApplianceConfigAirAirHeatPump> {
  get Icon() {
    return AcUnit
  }

  getDefaultConfig(): ApplianceConfigAirAirHeatPump {
    return Object.assign({
      advanced: false,
      strategy: 'MANUAL',
      plan_by_price: true,
      pv_priority: 14,
      saving_or_heat: 0,
      heat_preservation: 8,
      fixed_percentage: 40,
    }, super.getDefaultConfig())
  }

  drawSliders(): React.ReactNode {

    return (
      <StrategySliders
        key="sliders"
        name1="saving_or_heat"
        slider1={[this.app.t('More Saving'), this.app.t('More Heat')]}
        values1={[-100, 100]}
        value1={this.getConfig('saving_or_heat')}
        title1={this.app.t('Do you prefer?')}

        name2="heat_preservation"
        slider2={['4h', '24h']}
        values2={[4, 24]}
        value2={this.getConfig('heat_preservation')}
        title2={this.app.t('Time window of optimization?')}

        onChange={(k, v) => { this.setConfig(k, v); this.applyConfig() }}
      />
    )
  }

  convert() {
    const ctrl = this.getOptimizerControl()
    const advanced = this.getConfig('advanced')

    return Object.assign({
      min_duty: advanced ? ctrl.getConfig('min_duty') : 0,
      max_duty: advanced ? ctrl.getConfig('max_duty') : 100,
      min_duty_at: advanced ? ctrl.getConfig('min_duty_at') : Math.round(16 + 0.02 * (this.getConfig('saving_or_heat') as number)),
      max_duty_at: advanced ? ctrl.getConfig('max_duty_at') : Math.round(5 + 0.01 * (this.getConfig('saving_or_heat') as number)),
      time_constant: this.getConfig('heat_preservation'),
    }, super.convert())
  }
}
